import React, { useEffect, FC } from "react";
import { Table, Button, Input, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { useStockCheckDetailModel, IMaterialDetailModel } from "./stockCheckDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatIntPoint } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddMaterialModal: FC<RouterParamType> = ({ id, mode }) => {
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        initPgCfg,
        addModalVisible: visible,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        detailAddForm,
        detailEditForm,
        transformsToRoDetailList,
        resetWorkloadData,
        workloadData,
        setAddDataSource,
        setSearchWorkData,
        setWorkDataSource,
        setAddModalVisible } = useStockCheckDetailModel();

    useEffect(() => {
        if (visible && mode === "add") {
            let { warehouseCode, shelfCode } = detailAddForm as { warehouseCode: string, shelfCode: string }
            workloadData(initPgCfg, { warehouseCode, shelfCode: shelfCode.toString() })
            setSearchWorkData({ warehouseCode, shelfCode: shelfCode.toString() })
        } else if (visible && mode === "edit") {
            let { warehouseCode, shelfCode } = detailEditForm as { warehouseCode: string, shelfCode: string }
            workloadData(initPgCfg, { warehouseCode, shelfCode: shelfCode.toString() })
            setSearchWorkData({ warehouseCode, shelfCode: shelfCode.toString() })
        }
    }, [detailAddForm.warehouseCode, detailEditForm.warehouseCode, visible])

    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '库存',
            width: 120,
            dataIndex: 'inventoryNum',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '数量',
            width: 120,
            dataIndex: 'num',
            editable: true,
            rules: [{ required: true, message: "该项为必填" }, { transform: (value: any) => Number(value), pattern: /^\+?[1-9][0-9]*$/, message: '请输入正整数' }],
        },
        {
            title: '最新采购价格 ',
            width: 120,
            dataIndex: 'averagePurchasePrice',
        },
        {
            title: '最近销售价',
            width: 120,
            dataIndex: 'lateSalePrice',
        },
        {
            title: '档案进价',
            width: 120,
            dataIndex: 'purchasePrice',
        },
        {
            title: '金额',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={
                        !!addDataSource.find(item => item.id === record.id)
                    }
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockCheck", "roleCodes": roles };
        return getRoleColumns("stockCheck", "新增配件", newSelectColumns(optType), params);
    };

    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, inventoryNum, averagePurchasePrice } = row
        num = +formatIntPoint(num);
        averagePurchasePrice = +formatIntPoint(averagePurchasePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        let newRow = {
            ...row,
            amount: (num * averagePurchasePrice).toFixed(2)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, inventoryNum, averagePurchasePrice } = row
        num = +formatIntPoint(num);
        averagePurchasePrice = +formatIntPoint(averagePurchasePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        let newRow = {
            ...row,
            amount: (num * averagePurchasePrice).toFixed(2)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id !== record.id)
        setAddDataSource(filterAddDataSource)
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            onBlur={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value?.trim() }) }}
            placeholder="商品编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value?.trim() }) }}
            placeholder="商品名称"
        />
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">检索</Button>
        <Button onClick={() => mode === "add" ? resetWorkloadData({ warehouseCode: detailAddForm.warehouseCode }) : resetWorkloadData({ warehouseCode: detailEditForm.warehouseCode })} shape="round">重置</Button>
    </div>
    const onOK = async () => {
        transformsToRoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([])
        mode === "add" ? resetWorkloadData({ warehouseCode: detailAddForm.warehouseCode }) : resetWorkloadData({ warehouseCode: detailEditForm.warehouseCode })
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        title="选择用料"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                bordered
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workDataSource}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                bordered
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={addDataSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}